module.exports = __webpack_public_path__ + "static/x-920367d98718eed2b25f98677c8bb585.ico";